


// import React, { useEffect, useMemo, useRef, useState } from "react";
// import ReactQuill, { Quill } from "react-quill";
// import "react-quill/dist/quill.snow.css";

// // Para el picker de emojis
// import data from "@emoji-mart/data";
// import Picker from "@emoji-mart/react";

// // Icono de react-icons (puedes cambiarlo por otro)
// import { FaRegSmile, FaSmile } from "react-icons/fa";

// // Tu servicio de subida de archivos
// import { FileService } from "../../../../core/services/file/file.service";
// import { UploadFile } from "../../drag-drop/model/UploadFile";

// // 1) OPCIONAL: Personalizar enlaces con target=_blank
// const Link = Quill.import("formats/link");
// class MyLink extends Link {
//   static create(value: any) {
//     let node = super.create(value);
//     node.setAttribute("target", "_blank");
//     node.setAttribute("rel", "noopener noreferrer");
//     return node;
//   }
// }
// Quill.register(MyLink, true);

// interface MyRichTextEditorProps {
//   disabled?: boolean;
//   value: string;
//   onChange: (content: string) => void;
// }

// export const MyRichTextEditor: React.FC<MyRichTextEditorProps> = ({
//   disabled = false,
//   value,
//   onChange,
// }) => {
//   const quillRef = useRef<ReactQuill>(null);
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false);

//   /**
//    * Handler para subir imagen usando FileService.
//    */
//   const handleImageUpload = async (file: File): Promise<string> => {
//     try {
//       const uploadObj = new UploadFile(file, ["editor-images"]);
//       const { data } = await FileService.add(uploadObj, () => { });
//       if (data.ok && data.item?.[0]) {
//         // Ajusta la URL según tu backend
//         const pathRelative = `${data.item[0].destination}/${data.item[0].filename}`;
//         const fullUrl = `${process.env.REACT_APP_API_URL_MS_AUTH}/${pathRelative}`;
//         return fullUrl;
//       } else {
//         throw new Error("No se pudo subir la imagen");
//       }
//     } catch (error) {
//       console.error("Error subiendo imagen:", error);
//       return "";
//     }
//   };

//   /**
//    * Insertar imagen en la posición del cursor.
//    */
//   const insertImage = async () => {
//     const editor = quillRef.current?.getEditor();
//     if (!editor) return;

//     // Crear un input para seleccionar la imagen
//     const input = document.createElement("input");
//     input.type = "file";
//     input.accept = "image/*";
//     input.click();

//     input.onchange = async () => {
//       if (input.files && input.files[0]) {
//         const file = input.files[0];
//         const imageUrl = await handleImageUpload(file);
//         if (imageUrl) {
//           const range = editor.getSelection(true);
//           if (range) {
//             editor.insertEmbed(range.index, "image", imageUrl, "user");
//           }
//         }
//       }
//     };
//   };

//   /**
//    * Handler para abrir/cerrar el Picker de emojis.
//    */
//   const toggleEmojiPicker = () => {
//     if (disabled) return;
//     setShowEmojiPicker((prev) => !prev);
//   };

//   /**
//    * Insertar un emoji en la posición del cursor.
//    */
//   const insertEmoji = (emoji: any) => {
//     const editor = quillRef.current?.getEditor();
//     if (!editor) return;
//     const range = editor.getSelection(true);
//     if (range && emoji.native) {
//       editor.insertText(range.index, emoji.native);
//       setShowEmojiPicker(false);
//     }
//   };

//   /**
//    * Definimos la toolbar de forma MEMOIZADA,
//    * para que no se regenere en cada render.
//    */
//   const modules = useMemo(() => {
//     // Definimos un "toolbar personalizado"
//     return {
//       toolbar: {
//         container: "#my-quill-toolbar", // ID de un contenedor HTML (ver abajo)
//         handlers: {
//           image: insertImage, // Reemplaza el handler de Quill para 'image'
//         },
//       },
//     };
//   }, []);

//   return (
//     <div style={{ position: "relative" }}>
//       {/* TOOLBAR PERSONALIZADO */}
//       <div id="my-quill-toolbar" style={{ marginBottom: "8px" }}>
//         {/* Encabezados */}
//         <select className="ql-header" defaultValue={""}>
//           <option value="1" />
//           <option value="2" />
//           <option value="3" />
//           <option value="4" />
//           <option value="5" />
//           <option value="6" />
//           <option value="">Normal</option>
//         </select>

//         {/* Botones estándar */}
//         <button className="ql-bold" />
//         <button className="ql-italic" />
//         <button className="ql-underline" />
//         <button className="ql-strike" />
//         <button className="ql-blockquote" />

//         {/* Listas */}
//         <button className="ql-list" value="ordered" />
//         <button className="ql-list" value="bullet" />

//         {/* Indentación */}
//         <button className="ql-indent" value="-1" />
//         <button className="ql-indent" value="+1" />

//         {/* Alineación */}
//         <select className="ql-align" defaultValue={""}>
//           <option value="" />
//           <option value="center" />
//           <option value="right" />
//           <option value="justify" />
//         </select>

//         {/* Link, Imagen y Video */}
//         <button className="ql-link" />
//         <button className="ql-image" />
//         <button className="ql-video" />

//         {/* Botón de Emojis */}
//         <button
//           type="button"
//           onClick={toggleEmojiPicker}
//           className="ql-emoji-button"
//           style={{ marginLeft: "6px" }}
//         >
//           <FaRegSmile size={16} />
//         </button>

//         {/* Limpiar formato */}
//         <button className="ql-clean" />
//       </div>


//       {/* EDITOR */}
//       <ReactQuill
//         ref={quillRef}
//         readOnly={disabled}
//         value={value}
//         onChange={(content) => onChange(content)}
//         modules={modules}
//         theme="snow"
//         style={{ minHeight: 100 }}
//       />

//       {/* PICKER DE EMOJIS */}
//       {showEmojiPicker && (
//         <div
//           style={{
//             position: "absolute",
//             top: "50px",
//             right: "0",
//             zIndex: 999,
//             background: "#fff",
//           }}
//         >
//           <Picker
//             data={data}
//             onEmojiSelect={insertEmoji}
//             emojiSize={20}
//             locale="es"
//             theme="light"
//             maxFrequentRows={0}
//           />
//         </div>
//       )}
//     </div>
//   );
// };


// import React, { useEffect, useMemo, useRef, useState } from "react";
// import ReactQuill, { Quill } from "react-quill";
// import "react-quill/dist/quill.snow.css";

// // Para el picker de emojis
// import data from "@emoji-mart/data";
// import Picker from "@emoji-mart/react";

// // Icono de react-icons (puedes cambiarlo por otro)
// import { FaRegSmile } from "react-icons/fa";

// // Tu servicio de subida de archivos
// import { FileService } from "../../../../core/services/file/file.service";
// import { UploadFile } from "../../drag-drop/model/UploadFile";

// // 1) OPCIONAL: Personalizar enlaces con target=_blank
// const Link = Quill.import("formats/link");
// class MyLink extends Link {
//   static create(value: any) {
//     let node = super.create(value);
//     node.setAttribute("target", "_blank");
//     node.setAttribute("rel", "noopener noreferrer");
//     return node;
//   }
// }
// Quill.register(MyLink, true);

// interface MyRichTextEditorProps {
//   disabled?: boolean;
//   value: string;
//   onChange: (content: string) => void;
// }

// export const MyRichTextEditor: React.FC<MyRichTextEditorProps> = ({
//   disabled = false,
//   value,
//   onChange,
// }) => {
//   const quillRef = useRef<ReactQuill>(null);
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false);

//   /**
//    * Handler para subir imagen usando FileService.
//    */
//   const handleImageUpload = async (file: File): Promise<string> => {
//     try {
//       const uploadObj = new UploadFile(file, ["editor-images"]);
//       const { data } = await FileService.add(uploadObj, () => { });
//       if (data.ok && data.item?.[0]) {
//         const pathRelative = `${data.item[0].destination}/${data.item[0].filename}`;
//         const fullUrl = `${process.env.REACT_APP_API_URL_MS_AUTH}/${pathRelative}`;
//         return fullUrl;
//       } else {
//         throw new Error("No se pudo subir la imagen");
//       }
//     } catch (error) {
//       console.error("Error subiendo imagen:", error);
//       return "";
//     }
//   };

//   /**
//    * Insertar imagen en la posición del cursor.
//    */
//   const insertImage = async () => {
//     const editor = quillRef.current?.getEditor();
//     if (!editor) return;

//     const input = document.createElement("input");
//     input.type = "file";
//     input.accept = "image/*";
//     input.click();

//     input.onchange = async () => {
//       if (input.files && input.files[0]) {
//         const file = input.files[0];
//         const imageUrl = await handleImageUpload(file);
//         if (imageUrl) {
//           const range = editor.getSelection(true);
//           if (range) {
//             editor.insertEmbed(range.index, "image", imageUrl, "user");
//           }
//         }
//       }
//     };
//   };

//   /**
//    * Handler para abrir/cerrar el Picker de emojis.
//    */
//   const toggleEmojiPicker = () => {
//     if (disabled) return;
//     setShowEmojiPicker((prev) => !prev);
//   };

//   /**
//    * Insertar un emoji en la posición del cursor.
//    */
//   const insertEmoji = (emoji: any) => {
//     const editor = quillRef.current?.getEditor();
//     if (!editor) return;
//     const range = editor.getSelection(true);
//     if (range && emoji.native) {
//       editor.insertText(range.index, emoji.native);
//       setShowEmojiPicker(false);
//     }
//   };

//   /**
//    * Definimos la toolbar de forma MEMOIZADA,
//    * para que no se regenere en cada render.
//    */
//   const modules = useMemo(() => {
//     return {
//       toolbar: {
//         container: "#my-quill-toolbar",
//         handlers: {
//           image: insertImage,
//         },
//       },
//     };
//   }, []);

//   return (
//     <div style={{ position: "relative" }}>
//       {/* TOOLBAR PERSONALIZADO */}
//       <div
//         id="my-quill-toolbar"
//         style={{
//           marginBottom: "8px",
//           position: "sticky",
//           top: 65,
//           zIndex: 1000,
//           background: "#fff",
//           padding: "8px 0",
//         }}
//       >
//         {/* Encabezados */}
//         <select className="ql-header" defaultValue={""}>
//           <option value="1" />
//           <option value="2" />
//           <option value="3" />
//           <option value="4" />
//           <option value="5" />
//           <option value="6" />
//           <option value="">Normal</option>
//         </select>

//         {/* Botones estándar */}
//         <button className="ql-bold" />
//         <button className="ql-italic" />
//         <button className="ql-underline" />
//         <button className="ql-strike" />
//         <button className="ql-blockquote" />

//         {/* Listas */}
//         <button className="ql-list" value="ordered" />
//         <button className="ql-list" value="bullet" />

//         {/* Indentación */}
//         <button className="ql-indent" value="-1" />
//         <button className="ql-indent" value="+1" />

//         {/* Alineación */}
//         <select className="ql-align" defaultValue={""}>
//           <option value="" />
//           <option value="center" />
//           <option value="right" />
//           <option value="justify" />
//         </select>

//         {/* Link, Imagen y Video */}
//         <button className="ql-link" />
//         <button className="ql-image" />
//         <button className="ql-video" />

//         {/* Botón de Emojis */}
//         <button
//           type="button"
//           onClick={toggleEmojiPicker}
//           className="ql-emoji-button"
//           style={{ marginLeft: "6px" }}
//         >
//           <FaRegSmile size={16} />
//         </button>

//         {/* Limpiar formato */}
//         <button className="ql-clean" />
//       </div>

//       {/* EDITOR */}
//       <ReactQuill
//         ref={quillRef}
//         readOnly={disabled}
//         value={value}
//         onChange={(content) => onChange(content)}
//         modules={modules}
//         theme="snow"
//         style={{ minHeight: 100 }}
//       />

//       {/* PICKER DE EMOJIS */}
//       {showEmojiPicker && (
//         <div
//           style={{
//             position: "absolute",
//             top: "50px",
//             right: "0",
//             zIndex: 999,
//             background: "#fff",
//           }}
//         >
//           <Picker
//             data={data}
//             onEmojiSelect={insertEmoji}
//             emojiSize={20}
//             locale="es"
//             theme="light"
//             maxFrequentRows={0}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

// Para el picker de emojis
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

// Icono de react-icons (puedes cambiarlo por otro)
import { FaRegSmile } from "react-icons/fa";

// Tu servicio de subida de archivos
import { FileService } from "../../../../core/services/file/file.service";
import { UploadFile } from "../../drag-drop/model/UploadFile";

// 1) OPCIONAL: Personalizar enlaces con target=_blank
const Link = Quill.import("formats/link");
class MyLink extends Link {
  static create(value: any) {
    let node = super.create(value);
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
    return node;
  }
}
Quill.register(MyLink, true);

interface MyRichTextEditorProps {
  disabled?: boolean;
  value: string;
  directoriesImagefile?: string[];
  onChange: (content: string) => void;
}

export const MyRichTextEditor: React.FC<MyRichTextEditorProps> = ({
  disabled = false,
  value,
  onChange,
  directoriesImagefile = ["editor-images"],
}) => {
  const quillRef = useRef<ReactQuill>(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  /**
   * Handler para subir imagen usando FileService.
   */
  const handleImageUpload = async (file: File): Promise<string> => {
    try {
      const uploadObj = new UploadFile(file, directoriesImagefile);
      const { data } = await FileService.add(uploadObj, () => { });
      if (data.ok && data.item?.[0]) {
        const pathRelative = `${data.item[0].destination}/${data.item[0].filename}`;
        const fullUrl = `${process.env.REACT_APP_API_URL_MS_AUTH}/${pathRelative}`;
        return fullUrl;
      } else {
        throw new Error("No se pudo subir la imagen");
      }
    } catch (error) {
      console.error("Error subiendo imagen:", error);
      return "";
    }
  };

  /**
   * Insertar imagen en la posición del cursor.
   */
  const insertImage = async () => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;

    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.click();

    input.onchange = async () => {
      if (input.files && input.files[0]) {
        const file = input.files[0];
        const imageUrl = await handleImageUpload(file);
        if (imageUrl) {
          const range = editor.getSelection(true);
          if (range) {
            editor.insertEmbed(range.index, "image", imageUrl, "user");
          }
        }
      }
    };
  };

  /**
   * Handler para abrir/cerrar el Picker de emojis.
   */
  const toggleEmojiPicker = () => {
    if (disabled) return;
    setShowEmojiPicker((prev) => !prev);
  };

  /**
   * Insertar un emoji en la posición del cursor.
   */
  const insertEmoji = (emoji: any) => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;
    const range = editor.getSelection(true);
    if (range && emoji.native) {
      editor.insertText(range.index, emoji.native);
      setShowEmojiPicker(false);
    }
  };

  /**
   * Definimos la toolbar de forma MEMOIZADA,
   * para que no se regenere en cada render.
   */
  const modules = useMemo(() => {
    return {
      toolbar: {
        container: "#my-quill-toolbar",
        handlers: {
          image: insertImage,
        },
      },
    };
  }, []);

  return (
    <div style={{ position: "relative" }}>
      {/* TOOLBAR PERSONALIZADO */}
      <div
        id="my-quill-toolbar"
        style={{
          marginBottom: "8px",
          position: "sticky",
          top: 65,
          zIndex: 1000,
          background: "#fff",
          padding: "8px 0",
        }}
      >
        {/* Encabezados */}
        <select className="ql-header" defaultValue={""}>
          <option value="2">H2</option>
          <option value="3">H3</option>
          <option value="6">H6</option>
          <option value="">Normal</option>
        </select>

        {/* Botones estándar */}
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-strike" />
        <button className="ql-blockquote" />

        {/* Listas */}
        <button className="ql-list" value="ordered" />
        <button className="ql-list" value="bullet" />

        {/* Indentación */}
        <button className="ql-indent" value="-1" />
        <button className="ql-indent" value="+1" />

        {/* Alineación */}
        <select className="ql-align" defaultValue={""}>
          <option value="" />
          <option value="center" />
          <option value="right" />
          <option value="justify" />
        </select>

        {/* Link, Imagen y Video */}
        <button className="ql-link" />
        <button className="ql-image" />
        <button className="ql-video" />

        {/* Botón de Emojis */}
        <button
          type="button"
          onClick={toggleEmojiPicker}
          className="ql-emoji-button"
          style={{ marginLeft: "6px" }}
        >
          <FaRegSmile size={16} />
        </button>

        {/* Limpiar formato */}
        <button className="ql-clean" />
      </div>

      {/* EDITOR */}
      <ReactQuill
        ref={quillRef}
        readOnly={disabled}
        value={value}
        onChange={(content) => onChange(content)}
        modules={modules}
        theme="snow"
        style={{ minHeight: 100 }}
      />

      {/* PICKER DE EMOJIS */}
      {showEmojiPicker && (
        <div
          style={{
            position: "absolute",
            top: "50px",
            right: "0",
            zIndex: 999,
            background: "#fff",
          }}
        >
          <Picker
            data={data}
            onEmojiSelect={insertEmoji}
            emojiSize={20}
            locale="es"
            theme="light"
            maxFrequentRows={0}
          />
        </div>
      )}
    </div>
  );
};
